import {
    Card, Carousel, Image, theme, Typography,
} from 'antd';

import { formatPrice } from '@/utils';

const mockScripts = Array.from({ length: 10 }, (_, index) => ({
    id: `mock-script-${index + 1}`,
    title: `Lorem Ipsum Script ${index + 1}`,
    price: 1000 + index * 100,
    image: `https://placehold.co/200x150/4A90E2/ffffff?text=${String(index + 1).padStart(2, '0')}`,
}));

export const SimilarScriptsCarousel = () => {
    const { token } = theme.useToken();

    return (
        <Card title="Крос-сейли" size="small">
            <Carousel
                dots={true}
                arrows={true}
                draggable={true}
                slidesToShow={4}
                slidesToScroll={1}
                infinite={false}
            >
                {mockScripts.map((script) => (
                    <div key={script.id}>
                        <div style={{ padding: `0 ${token.paddingXXS}px` }}>
                            <Card
                                size="small"
                                cover={
                                    <Image
                                        src={script.image}
                                        alt={script.title}
                                        preview={false}
                                        style={{ width: '100%', height: 150, objectFit: 'cover' }}
                                    />
                                }
                            >
                                <Typography.Text strong style={{ display: 'block', marginBottom: 4 }}>
                                    {script.title}
                                </Typography.Text>
                                <Typography.Text type="secondary">
                                    {formatPrice(script.price, 'UAH')}
                                </Typography.Text>
                            </Card>
                        </div>
                    </div>
                ))}
            </Carousel>
        </Card>
    );
};
